import Guid from '@/app/utils/guid'
import NodeEntity from '@/common/models/node-entitiy'

export default class TopicGroup extends NodeEntity {

    public projectId = Guid.empty()
    public reactiveMessage = ''
    public proactiveMessage = ''
    public order = 0
}
